var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoenArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99954 7.09375L10.0079 2.08542L8.83038 0.90625L4.99954 4.73958L1.16954 0.90625L-0.00878906 2.08458L4.99954 7.09375Z",
    fill: "#1F384C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoenArrow);
export default __webpack_public_path__ + "static/media/doenArrow.6deec6f4cf7f7470ada001e570e831ba.svg";
export { ForwardRef as ReactComponent };